import { render, staticRenderFns } from "./kanban_config.vue?vue&type=template&id=67f06d8d&scoped=true"
import script from "./kanban_config.vue?vue&type=script&lang=js"
export * from "./kanban_config.vue?vue&type=script&lang=js"
import style0 from "./kanban_config.vue?vue&type=style&index=0&id=67f06d8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f06d8d",
  null
  
)

export default component.exports